// tslint:disable
export enum AccountPhoneContactInformationType {
    // UNKN
    UNKN = 0,
    // PHONE
    PHONE = 1,
    // MOBILE
    MOBILE = 2,
    // FAX
    FAX = 3,
    // WEB
    WEB = 4,
    // E-MAIL
    EMAIL = 5,
    // DNC
    DNC = 6,
    // FACEBOOK
    FACEBOOK = 7,
    // TWITTER
    TWITTER = 8,
    // LINKEDIN
    LINKEDIN = 9,
    // GOOGLEPLUS
    GOOGLEPLUS = 10,
    // YOUTUBE
    YOUTUBE = 11,
    // Text
    Text = 12,
    // Mail
    Mail = 13,
    // MANGO
    MANGO = 14,
}
(AccountPhoneContactInformationType as any)['TEXT'] = 12;
(AccountPhoneContactInformationType as any)['MAIL'] = 13;
